import clsx from "clsx";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import type { CardGridStoryblok } from "@/types/blok-types";
import styles from "./card-grid.module.css";

const CardGrid = ({
  blok,
  preview,
}: {
  blok: CardGridStoryblok;
  preview: boolean;
}): React.JSX.Element => {
  return (
    <div
      className={clsx(styles.root, "card-grid")}
      style={{ gridTemplateColumns: `repeat(${blok.cards.length},1fr)` }}
      data-layout="blok"
    >
      {blok.cards.map((card) => {
        return (
          <div key={card._uid} className={styles.card} data-layout="blok">
            <StoryblokComponent blok={card} preview={preview} />
          </div>
        );
      })}
    </div>
  );
};

export default CardGrid;
